import { useState, useEffect } from "react";
import { Button, Form, Input, Drawer } from "antd";

import TEXT from "../../../config/text";
import REQUESTS from "../../../api/requests";
import ErrorMessage from "../../../components/ErrorMessage";
import classes from "../style/serverDrawer.module.scss";


const ServerDrawer = ({
  onClose,
  visible,
  current,
  getData,
  translation,
  followAddElement,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    type: false,
    text: "",
  });

  const onValuesChange = (e) => {
    setMessage({
      type: false,
      text: "",
    });
  };

  useEffect(() => {
    if (visible === false) {
      setLoading(false);
    }
  }, [visible]);

  const onFinish = (values) => {
    const { external_api, name, host } = values;

    setLoading(true);

    const body = {
      name: name,
      host: host,
      external_api:external_api || "",
    };

    function callback() {
      if (!current) {
        followAddElement.setCurrentPage(1);
        followAddElement.setSearch("");
        followAddElement.setSort(["id", "DESC"]);
        followAddElement.setCurrentPage(1);
        followAddElement.setLimit(10);
        followAddElement.setTotal();
        followAddElement.setDate("");
      }
      setLoading(false);
      onClose();
      getData();
    }

    function errorCallback(err) {
      setLoading(false);
      setMessage({ type: false, text: err });
    }

    if (current) {
      body.id = current.id;
      REQUESTS.SERVER.EDIT(body, callback, errorCallback);
    } else {
      REQUESTS.SERVER.ADD(body, callback, errorCallback);
    }

  };

  useEffect(() => {
    if (current) {
      form.setFields([
        {
          name: "name",
          value: current.name,
        },

        {
          name: "host",
          value: current.host,
        },
        {
          name: "external_api",
          value: current.external_api,
        },

        {
          name: "price",
          value: current.price,
        },
      ]);
    } else {
      form.resetFields();
    }
  }, [current, visible]);

  return (
    <Drawer
      title={`${current ? "Edit" : "Add"} Server`}
      placement="right"
      onClose={onClose}
      visible={visible}
    >
      <Form
        form={form}
        name="profile"
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        initialValues={{
          password: "",
        }}
      >
        <Form.Item
          label={translation["Name"] || TEXT["Name"]}
          name="name"
          rules={[
            {
              required: true,
              message: "Please input your Name!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={translation["Host"] || TEXT["Host"]}
          name="host"
          rules={[
            {
              required: true,
              message: "Please input your Host!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={translation["External API link"] || TEXT["External API link"]}
          name="external_api"
        >
          <Input />
        </Form.Item>

        <ErrorMessage message={message} />
        <div className={classes["save_button_div"]}>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={classes["save_button"]}
              loading={loading}
            >
              {translation["Save"] || TEXT["Save"]}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
};

export default ServerDrawer;
